import styles from "./style.module.scss";
import Spinner from "../spinner";
export default function LoaderGlobal() {
    return (
        <section className={`${styles["loader"]} `}>
            <Spinner size={50} color="#0e2550" success={false} />
        </section>
    );
}
